import React from 'react';
import { UserList } from '@saleshandy/icons';
import GetContactDetail from '../../../../prospect/components/prospect-list/components/modals/get-contact-info-modal';
import { LeadRevealType } from '../../../types';

interface CreditNotAvailableModalProps {
  show: boolean;
  onHide: () => void;
  onAddCredits: () => void;
  revealType: LeadRevealType;
}

const getModalTitle = (revealType: LeadRevealType): string => {
  if (revealType === LeadRevealType.Company) {
    return 'Add credits to enrich company details';
  }
  return 'Add credits to see contact information';
};

const CREDIT_COST_MAP: Record<string, string> = {
  [LeadRevealType.Email]: '1 credit',
  [LeadRevealType.Phone]: '6 credits',
  [LeadRevealType.PersonalEmail]: '2 credits',
  [LeadRevealType.EmailPhone]: '7 credits',
  [LeadRevealType.PersonalEmailPhone]: '8 credits',
  [LeadRevealType.EmailPersonalEmail]: '3 credits',
  [LeadRevealType.EmailPersonalEmailPhone]: '9 credits',
};

const getCreditMessage = (revealType: LeadRevealType): string => {
  if (revealType === LeadRevealType.Company) {
    return "You don't have enough lead finder credits to enrich company details. Enriching one company requires 0.1 credits.";
  }
  const cost =
    CREDIT_COST_MAP[revealType] ||
    '1 credit for work email and 2 credits for personal email';
  return `You don't have enough lead finder credits to view all the selected leads, as it requires ${cost} per lead.`;
};

const CreditNotAvailableModal: React.FC<CreditNotAvailableModalProps> = ({
  show,
  onHide,
  onAddCredits,
  revealType,
}) => (
  <GetContactDetail
    show={show}
    onHide={onHide}
    onDelete={onAddCredits}
    title={getModalTitle(revealType)}
    icon={<UserList width={18} height={18} className="orange-txt-14" />}
    content={
      <>
        <div className="mt-2">
          <span className="regular-2 blue-txt-15">
            {getCreditMessage(revealType)}
          </span>
        </div>
        <div className="second-line-get-contact-modal">
          <span className="regular-2">
            Please add more credits or upgrade your plan to continue.
          </span>
        </div>
      </>
    }
    submitButtonText="Add Credits"
  />
);

export default CreditNotAvailableModal;
